<template>
  <setting-layout
    :title="title"
    :subtitle="subtitle"
    :save-disabled="saveDisabled"
    @cancel="cancel"
    @save="save"
  >
    <div v-if="canEdit && hasValidationError" class="red--text text-body-2 mt-4 mb-2">
      請填寫所有回覆內容
    </div>

    <FaqPresetSection :items.sync="presets" :can-edit="canEdit" />
    <v-divider class="my-7" />
    <FaqCustomSection :items.sync="customs" :can-edit="canEdit" />
  </setting-layout>
</template>

<script>
import SettingLayout from './SettingLayout'
import FaqPresetSection from './FaqPresetSection'
import FaqCustomSection from './FaqCustomSection'
import { getClinicFaqsAPI, saveClinicFaqsAPI } from '@/api'
import { mapGetters } from 'vuex'

export default {
  name: 'ClinicFaq',
  inject: ['getIsEdit', 'toggleEdit', 'toggleLoading', 'saveAlert'],
  components: { SettingLayout, FaqPresetSection, FaqCustomSection },
  props: {
    title: {
      required: true,
      type: String
    },
    subtitle: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      oPresets: [],
      oCustoms: [],
      presets: [],
      customs: []
    }
  },
  computed: {
    ...mapGetters(['axiosParamData']),
    canEdit() {
      return this.getIsEdit()
    },
    hasValidationError() {
      const presetError = this.presets.some(p =>
        p.options.some(o => !o.option_text || !o.option_text.trim() || o.option_text.length > 225)
      )
      if (presetError) return true

      const customError = this.customs.some(c =>
        !c.question || !c.question.trim() ||
        c.options.some(o => !o.option_text || !o.option_text.trim() || o.option_text.length > 225)
      )
      return customError
    },
    saveDisabled() {
      return this.hasValidationError
    }
  },
  methods: {
    save() {
      if (this.hasValidationError) return
      this.toggleLoading(true)

      const data = {
        clinic_code: this.axiosParamData.clinic_code,
        presets: this.presets.map(p => ({
          id: p.id,
          is_enabled: p.is_enabled,
          options: p.options.map(o => ({
            ...(o.id ? { id: o.id } : {}),
            option_text: o.option_text,
            is_selected: o.is_selected
          }))
        })),
        customs: this.customs.map((c, i) => ({
          ...(c.id ? { id: c.id } : {}),
          question: c.question,
          is_enabled: c.is_enabled,
          sort_order: i + 7,
          options: c.options.map(o => ({
            ...(o.id ? { id: o.id } : {}),
            option_text: o.option_text
          }))
        }))
      }

      saveClinicFaqsAPI(data).then(res => {
        this.setData(res.data)
        this.toggleEdit(false)
        this.saveAlert()
      }).catch(e => {
        console.error(e)
      }).finally(() => {
        this.toggleLoading(false)
      })
    },
    cancel() {
      this.resetData()
    },
    resetData() {
      this.presets = JSON.parse(JSON.stringify(this.oPresets))
      this.customs = JSON.parse(JSON.stringify(this.oCustoms))
    },
    setData(data) {
      this.oPresets = JSON.parse(JSON.stringify(data.presets || []))
      this.oCustoms = JSON.parse(JSON.stringify(data.customs || []))
      this.resetData()
    },
    getData() {
      this.toggleLoading(true)
      getClinicFaqsAPI(this.axiosParamData).then(res => {
        this.setData(res.data)
      }).finally(() => {
        this.toggleLoading(false)
      })
    }
  },
  mounted() {
    this.getData()
  }
}
</script>
